<template>
    <div class="disable-scroll-x">
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <CRow class="ml-5 mr-5 mb-5">
          <Mainlayout></Mainlayout>
          <br /><br /><br />
        </CRow>
  
        <CContainer>
          <div class="text-center d-sm-down-none">
            <h3 class="custom-64px text-white text-center">Education Center</h3>
          
          </div>
  
          <div class="text-center d-md-none">
            <h3 class="custom-32px text-white text-center">Education Center</h3>
           
          </div>
        </CContainer>
  
        <CRow>
          <div class="card-custom-web">
          
            <div class="text-center" style="background-size: cover;background-repeat: no-repeat;"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
              <h1 class="ml-5 mt-5 custom-64px text-center d-sm-down-none">
                <strong>Register your Education Center</strong>
              </h1>
  
              <h1 class="ml-5 mt-5 custom-24px text-center d-md-none">
                <strong>Register your Education Center</strong>
              </h1>
  
              <label class="ml-2 mr-2 d-sm-down-none"
                >Fill up all the form on following below.</label
              >
              <label class="ml-2 mr-2 d-md-none"
                >Fill up all the form on following below.</label
              >
  
              <CContainer class="text-left mt-4 paddingweb">
                <CCard class="p-3">
                  <div v-if="this.ErrorPasswordHash===true" class="ml-4 mr-4">
                          <CAlert show color="danger"
                            >The password does not match </CAlert
                          >
                        </div>
               
                <CRow>
                   <CCol sm="12">
                Email
                <br />
                <CInput type="text" v-model="Email"/>
              </CCol>
              <CCol sm="12">
                Username
                <br />
                <CInput type="text" v-model="Username" />
              </CCol>
              <CCol sm="12">
                Password
                <br />
                <CInput type="password" v-model="PasswordHash"/>
              </CCol>
              <CCol sm="12">
                Confirm Password
                <br />
                <CInput type="password" v-model="PasswordHashCopy"/>
              </CCol>
              <hr />
               <CCol sm="12">
                School/Company name
                <br />
                <CInput type="text" v-model="Name"/>
                 
              </CCol>
               <CCol sm="12">
                Description
                <br />
                <CInput type="text" v-model="Description"/>
              </CCol>
               <CCol sm="12">
                Phone Number
                <br />
                <CInput type="text" v-model="PhoneNumber"/>
              </CCol>
                 <!-- <CCol sm="12">
                Code
                <br />
                <CInput type="number" v-model="Code"/> -->
                <br />
                <!-- <br />
                Choose Package
                <v-select v-model="SelectedPackage"
                              :options="packages"
                              label="PackageName"
                              placeholder="--Please Select Package--"
                            >  </v-select>
                        <br /> -->
                 <CButton
                type="button"
                color="primary"
                class="btn custom-btn-login-forgot btn-info ml-3"
                @click="SubmitAdmin"
                >Register</CButton
              >
              <br /><br /><br />
              <!-- </CCol> -->
                </CRow>
              </CCard>
              </CContainer>
            </div>
         

            <div>
        <CContainer class="text-center">
          <CCard class="custom-bg-orange-card mt-3">
            <CRow class="p-2">
              <div style="width: 70%" class="p-3">
                <h3
                  style="white-space: nowrap"
                  class="custom-32px text-left mt-3 d-sm-down-none"
                >
                  Interested to register as an Organisation?
                </h3>
                <h3 class="custom-16px text-left mt-3 d-md-none text-white">
                  Interested to register as an Organisation?
                </h3>
                <label class="text-white text-left mt-3"
                  >Are you an big organisation or interested to register for
                  many students. Please contact us below for further
                  details.</label
                >
                <br />
                <div class="text-left">
                  <CButton
                    color="info"
                    class="custom-btn-login-active-signin text-left mt-2"
                  >
                  <a href="https://wa.me/600106597700?text=+Hi, I interested to register as an Organisation">
                    Contact Us Now
                    </a></CButton
                  >
                </div>
              </div>
              <div style="width: 30%">
                <img
                  style=" max-width: 300px;right: 0;position: absolute;bottom: 0;
                  " src="../assets/img/icon/organization.svg" class="d-sm-down-none"
                />
              </div>
            </CRow>
          </CCard>
          <CCol sm="12" class="p-0">
            <CRow class="p-0">
              <CCol sm="6" class="p-0">
                <div class="text-left">
                  <CCard class="custom-bg-color-yellow mt-3 custom-height-card">
                    <CRow>
                      <div style="width: 100%">
                        <h3
                          style="text-align: left"
                          class="header-card mt-3 ml-4"
                        >
                          <strong>Let’s Register with Us</strong>
                        </h3>
                        <br />
                      </div>
                      <div style="width: 60%" class="float-left">
                        <label class="header-card-subtitle ml-4">
                          Sign Up with Pickiddo to enjoy full benefits of
                          educations</label
                        >
                        <br /><br /><br />
                        <CButton
                          color="info"
                          class="
                            custom-btn-login-active-signin
                            float-left
                            text-left
                            ml-4
                            mb-2
                          "
                        >
                        <a href="https://wa.me/600106597700?text=+Hi, I would like to register with Pickiddo">
                          Sign Up</a></CButton
                        >
                      </div>
                      <div style="width: 40%" class="float-right">
                        <br /><br />
                        <img
                          style="
                            max-width: 50%;
                            right: 0;
                            position: absolute;
                            bottom: 0;
                          "
                          src="../assets/img/icon/twostudent.svg"
                        />
                      </div>
                    </CRow>
                  </CCard>
                </div>
              </CCol>
              <CCol sm="6" class="p-0">
                <div class="text-left">
                  <CCard class="custom-bg-color-yellow mt-3 custom-height-card">
                    <CRow>
                      <div style="width: 100%">
                        <h3
                          style="text-align: left"
                          class="header-card mt-3 ml-4"
                        >
                          <strong>Earn More With Pickiddo</strong>
                        </h3>
                        <br />
                      </div>
                      <div style="width: 60%" class="float-left">
                        <label class="header-card-subtitle ml-4">
                          Let’s help younger generations by educating
                          them.</label
                        >
                        <br /><br /><br />
                        <CButton
                          color="info"
                          class="custom-btn-login-active-signin ml-4 mb-2"
                        >
                        <a href="https://app.pickiddo.com/v3/#/LoginPickiddo">
                          Become a Tutor</a></CButton
                        >
                        <br />
                      </div>
                      <div style="width: 40%" class="float-right">
                        <br /><br />
                        <img
                          style="
                            max-width: 100%;
                            right: 0;
                            position: absolute;
                            bottom: 0;
                          "
                          src="../assets/img/icon/teacherchat.png"
                        />
                      </div>
                    </CRow>
                  </CCard>
                </div>
              </CCol>
            </CRow>
          </CCol>
          <br /><br /><br /><br />
        </CContainer>
      </div>
          </div>
        </CRow>
  
       
      </div>
  
      <Footerlayout></Footerlayout>
    </div>
  </template>
      
      
      
      
      <script>
  import Vue from "vue";
  import { Carousel3d, Slide } from "vue-carousel-3d";
  import AnimatedNumber from "animated-number-vue";
  import backgroundBanner from "../assets/img/icon/bannerformcopy.png";
  
  // import Translator from "vue-gtranslate";
  // import "vue-gtranslate/translator.css";
  
  Vue.use(require("vue-moment"));
  import VuejsDialog from "vuejs-dialog";
  import "vuejs-dialog/dist/vuejs-dialog.min.css";
  
  import Mainlayout from "../containers/AllHeaderLanding.vue";
  import Footerlayout from "../containers/TheFooter.vue";
  
  import VueAgile from "vue-agile";
  Vue.use(VueAgile);
  
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
  
  import _ from "lodash";
  new Vue({
    el: "#navbar",
  
    data() {
      return {
        view: {
          topOfPage: true,
        },
      };
    },
    beforeMount() {
      window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
      handleScroll() {
        if (window.pageYOffset > 400) {
          if (this.view.topOfPage) {
            this.view.topOfPage = false;
            el.setAttribute("style", "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)");
          }
        } else {
          if (!this.view.topOfPage) this.view.topOfPage = true;
          el.setAttribute("style", "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)");
        }
      },
    },
  });
  export default {
    name: "Login",
    components: {
      Mainlayout,
      Footerlayout,
      
    },
    data() {
      return {
        Email: "",
     Username: "",
     PasswordHash: "",
     TuitionCenterId: "",
     Description: "",
     PhoneNumber: "",
     Code: "",
     SelectedPackage: "",
     packages: [],

     PasswordHashCopy: "",
     backgroundBanner,
     ErrorPasswordHash:false,
      };
    },
    created() {
      AOS.init();
    },
    mounted() {
      window.addEventListener("scroll", this.onScroll);
    },
    async mounted() {
      this.GetPackages();
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.onScroll);
    },
    computed: {},
  
    methods: {
      getBadge (status) {
        switch (status) {
          case 'Active': return 'success'
          case 'Inactive': return 'secondary'
          case 'Pending': return 'warning'
          case 'Banned': return 'danger'
          default: 'primary'
        }
      },
      onScroll() {
        // Get the current scroll position
        const currentScrollPosition =
          window.pageYOffset || document.documentElement.scrollTop;
        // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
        if (currentScrollPosition < 0) {
          return;
        }
        // Here we determine whether we need to show or hide the navbar
        this.showNavbar = currentScrollPosition < this.lastScrollPosition;
        // Set the current scroll position as the last scroll position
        this.lastScrollPosition = currentScrollPosition;
      },
      handleScroll() {
        if (window.pageYOffset > 1000) {
          if (this.view.topOfPage) {
            this.view.topOfPage = false;
          } else {
            this.view.topOfPage = true;
          }
        }
      },
      async SubmitAdmin() {
        if(this.PasswordHashCopy != this.PasswordHash)
        {
          this.ErrorPasswordHash = true;
        }
        else
        {
          this.Busy = true;
      const formData = new FormData();

      formData.append("Email", this.Email);
      formData.append("Username", this.Username);
      formData.append("PasswordHash", this.PasswordHash);
      formData.append("Description", this.Description);
       formData.append("Name", this.Name);
         formData.append("PhoneNumber", this.PhoneNumber);
      formData.append("PackageId", this.$route.query.PackageId);

      return this.$API
        .post(this.$InsertRegisterAdmin, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
              window.open("https://ctr.pickiddo.com", "_self");
          } else {
            this.Busy = false;
            this.$dialog
              .alert("Error to create packagess")
              .then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });

        }
      
    },
    async GetPackages() {
      
      return this.$API
        .get(this.$GetListPackage)
        .then(
          function (response) {
            this.packages = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    },
  };
  </script>
          <<style scoped>
      
      @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
      @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
          
      .c-header {
        /* background: rgb(23, 77, 124);
        background: linear-gradient(92deg, #174d7c, #1b7682);
        border-bottom: 0.01px solid #1a6783;
        border-bottom: 1px solid #636f83; */
      
        background: transparent;
        border-bottom: 0;
        border-bottom: 0;
        /* color: #fff; */
      }
      .c-app{
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        font-family: 'Montserrat', sans-serif;
      }
      body {
        font-family: "Montserrat", sans-serif;
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      }
      h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
          margin-bottom: 0.5rem;
          font-weight: 500;
          line-height: 1.2;
          font-family: "Montserrat", sans-serif;
      }
      label
      {
        font-family: "Montserrat", sans-serif;
      }
      
      body nav.onScroll {
        box-shadow: 0 0 10px #aaa;
        background-color: rgb(255, 255, 255);
        font-family: 'Montserrat';
      font-style: normal;
      }
      body nav.onScroll ul li {
        color: #10b761;
      }
      body nav ul {
        margin-left: 3em;
        width: 25%;
        display: flex;
        justify-content: space-between;
      }
      body nav ul li {
        cursor: pointer;
        font-weight: 600;
        list-style-type: none;
        color: white;
      }
      body {
          top: 0 !important;
          font-family: 'Montserrat', sans-serif;
      }
    
      
    input {
      border-bottom: 2px solid #fff;
      background: none;
      border-top: none;
      border-left: none;
      border-right: none;
      width: -webkit-fill-available;
       -webkit-text-fill-color: white !important;
    
    }
    input ::placeholder {
      color: #e0e0e0;
    }
    
    ::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #e0e0e0;
    }
    .custom-user-input {
      /* Body/1/Semibold */
    
      display: flex;
      justify-content: center;
      flex-flow: row nowrap;
    }
  
  
  .js-click:active{
    background:#E8F4FF;
    border-radius:20px;
    border:1px solid #E8F4FF;
  }
  
  .js-click:focus{
    background:#E8F4FF;
    border-radius:20px;
    border:1px solid #E8F4FF;
  }
  
       </style>